import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Stack, IconButton } from '@mui/material';

// project import
import DrawerHeaderStyled from './DrawerHeaderStyled';

// ==============================|| DRAWER HEADER ||============================== //

const DrawerHeader = ({ open }) => {
	const theme = useTheme();
	const logoSrc = '/images/logo-light.png';
	const logoHeight = open ? 28 : 24;

	return (
		<DrawerHeaderStyled theme={theme} open={open}>
			<Stack
				className="header-logo"
				direction="row"
				spacing={0}
				alignItems="center"
				justifyContent={open ? 'flex-start' : 'center'}
				sx={{ width: '100%' }}
			>
				{open ? (
					<IconButton
						component={Link}
						to="/"
						disableRipple
						sx={{
							color: 'brandDark.contrastText',
							width: open ? 'auto' : 28,
							height: open ? 'auto' : 28,
							minWidth: open ? 'auto' : 28,
							minHeight: open ? 'auto' : 28,
							padding: 0,
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'center',
							alignItems: 'center',
							'&:hover': { color: 'secondary.lighter' },
						}}
					>
						<img src={logoSrc} alt="LynOrg" height={logoHeight} />
					</IconButton>
				) : null}
			</Stack>
		</DrawerHeaderStyled>
	);
};

DrawerHeader.propTypes = {
	open: PropTypes.bool,
};

export default DrawerHeader;
